import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiAcuerdosGestores } from 'api-rest';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'managers-agreements-indirect-agreement-cod-ler-modal',
  templateUrl: './indirect-agreement-cod-ler-modal.component.html',
  styleUrls: ['./indirect-agreement-cod-ler-modal.component.scss']
})
export class IndirectAgreementCodLerModalComponent {
  formGroup: FormGroup;
  relacion: any;
  consentimiento: any;
  codigosLer: any[] = [];
  codigosLerDisponibles: any[] = [];
  isConsentimientoMode = false;
  hasChanges = false;
  pageNumber = 1;
  pageSize = 10;
  recordsTotal = 0;
  itemsPerPageOptions: number[] = [5, 10, 25, 50];
  selectedItemsPerPage = 5;
  gridArray: any[] = [];
  isReadOnly = false;
  headArray: any[] = [
    {
      Head: 'Codigo LER',
      FieldName: 'tipoCodigo',
    },
    {
      Head: 'Descripcion',
      FieldName: 'descripcion',
      Tooltip: true,
    },
    {
      Head: 'PELIGROSIDAD',
      FieldName: 'peligrosidad',
      renderValue: (item: any) => (item?.peligrosidad ? 'Sí' : 'No'),
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Eliminar codigo LER',
          show: { params: 'canDeleteCodLer', accion: 'delete' },
        },
      ],
      width: '1',
      permanent: true,
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IndirectAgreementCodLerModalComponent>,
    private formBuilder: FormBuilder,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    @Inject(ApiAcuerdosGestores.PoseedoresAcuerdoControllerService)
    private poseedoresAcuerdoControllerSrv: ApiAcuerdosGestores.PoseedoresAcuerdoControllerService,
    @Inject(ApiAcuerdosGestores.ConsentimientoControllerService)
    private consentimientoControllerSrv: ApiAcuerdosGestores.ConsentimientoControllerService,
  ) {
    this.formGroup = this.formBuilder.group({
      codigosLerNuevos: [[]],
    });

    this.relacion = data?.relacion;
    this.consentimiento = data?.consentimiento;
    this.isConsentimientoMode = !!this.consentimiento?.id;
    this.isReadOnly = !!data?.soloLectura;

    if (this.isConsentimientoMode) {
      this.isReadOnly = this.consentimiento?.estado?.id !== 2;
      this.codigosLer = this.sortByOrden(this.consentimiento?.codigoLer ?? []);
      const allCodigosLer = data?.codigosLerDisponibles ?? [];
      this.codigosLerDisponibles = this.buildAvailableCodigos(allCodigosLer, this.codigosLer);
    } else {
      this.codigosLer = this.sortByOrden(this.relacion?.codigoLer ?? []);
    }

    this.recordsTotal = this.codigosLer.length;
    this.rebuildGrid();
  }

  cerrar(): void {
    this.dialogRef.close({ saved: this.hasChanges });
  }

  canDeleteCodLer(): boolean {
    if (this.isConsentimientoMode) {
      return !this.isReadOnly && this.consentimiento?.estado?.id === 2;
    }
    return !this.isReadOnly && this.relacion?.estado?.id === 2;
  }

  private sortByOrden(items: any[]): any[] {
    return [...items].sort((a: any, b: any) => (a?.orden ?? 0) - (b?.orden ?? 0));
  }

  private rebuildGrid(): void {
    const start = (this.pageNumber - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.gridArray = this.codigosLer.slice(start, end).map((ler: any) => ({
      ...ler,
      canDeleteCodLer: this.canDeleteCodLer(),
    }));
  }

  renderPage(event: number): void {
    this.pageNumber = event;
    this.rebuildGrid();
  }

  onItemsPerPageChange(): void {
    this.pageSize = this.selectedItemsPerPage;
    this.pageNumber = 1;
    this.rebuildGrid();
  }

  checked(_: any): void {
    return;
  }

  get codigosLerNuevosControl(): FormControl {
    return this.formGroup.get('codigosLerNuevos') as FormControl;
  }

  action(item: any): void {
    if (item?.nameButton === 'delete' && item?.id) {
      this.eliminarCodLer(item.id);
    }
  }

  eliminarCodLer(lerId: number): void {
    if (!this.canDeleteCodLer()) {
      return;
    }

    if (this.isConsentimientoMode) {
      const removed = this.codigosLer.find((item: any) => item?.id === lerId);
      this.codigosLer = this.sortByOrden(this.codigosLer.filter((item: any) => item?.id !== lerId));
      if (removed?.id && !this.codigosLerDisponibles.some((item: any) => item?.id === removed.id)) {
        this.codigosLerDisponibles = this.sortByOrden([...this.codigosLerDisponibles, removed]);
      }
      this.recordsTotal = this.codigosLer.length;
      this.rebuildGrid();
      this.hasChanges = true;
      return;
    }

    const updatedCodigos = this.codigosLer.filter((item: any) => item?.id !== lerId);
    const updatePayload = {
      ...this.relacion,
      codigoLer: updatedCodigos,
    };

    this.spinnerSrv.loadingShow();
    this.poseedoresAcuerdoControllerSrv.updateById(this.relacion.id, updatePayload).subscribe({
      next: (res: any) => {
        this.spinnerSrv.loadingHide();
        this.relacion = res ?? updatePayload;
        this.codigosLer = this.sortByOrden(this.relacion?.codigoLer ?? updatedCodigos);
        this.recordsTotal = this.codigosLer.length;
        if (this.pageNumber > 1 && this.codigosLer.length <= (this.pageNumber - 1) * this.pageSize) {
          this.pageNumber -= 1;
        }
        this.rebuildGrid();
        this.hasChanges = true;
        this.snackBarSrv.showSnackBar('Codigo LER eliminado correctamente', 'success');
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al eliminar el codigo LER', 'error');
      },
    });
  }

  addCodigosLer(): void {
    if (!this.isConsentimientoMode) {
      return;
    }

    const selectedIds: number[] = this.formGroup.get('codigosLerNuevos')?.value ?? [];
    if (!selectedIds.length) {
      this.snackBarSrv.showSnackBar('Debe seleccionar al menos un codigo LER para anadir', 'error');
      return;
    }

    const selected = this.codigosLerDisponibles.filter((item: any) => selectedIds.includes(item?.id));
    if (!selected.length) {
      return;
    }

    const byId = new Map<number, any>();
    this.codigosLer.forEach((item: any) => byId.set(item.id, item));
    selected.forEach((item: any) => byId.set(item.id, item));

    this.codigosLer = this.sortByOrden(Array.from(byId.values()));
    this.codigosLerDisponibles = this.sortByOrden(
      this.codigosLerDisponibles.filter((item: any) => !selectedIds.includes(item?.id))
    );
    this.formGroup.get('codigosLerNuevos')?.setValue([]);
    this.recordsTotal = this.codigosLer.length;
    this.rebuildGrid();
    this.hasChanges = true;
  }

  saveConsentimientoCodigos(): void {
    if (!this.isConsentimientoMode || !this.consentimiento?.id) {
      return;
    }

    if (this.consentimiento?.estado?.id !== 2) {
      this.snackBarSrv.showSnackBar('Solo se pueden modificar codigos LER en estado Generar consentimiento', 'error');
      return;
    }

    const payload: ApiAcuerdosGestores.ConsentimientoDTO = {
      //...this.consentimiento,
      id: this.consentimiento.id,
      codigoDocumento: this.consentimiento?.codigoDocumento,
      codigoLer: this.codigosLer.map((item: any) => ({
        id: item?.id,
        orden: item?.orden,
        tipoCodigo: item?.tipoCodigo,
        descripcion: item?.descripcion,
        peligrosidad: item?.peligrosidad,
        poseedores: item?.poseedores,
        ptosRecogida: item?.ptosRecogida,
        sddrCA: item?.sddrCA,
        codigo: item?.codigo,
      })),
    } as any;

    this.spinnerSrv.loadingShow();
    this.consentimientoControllerSrv.updateById1(this.consentimiento.id, payload).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.hasChanges = true;
        this.snackBarSrv.showSnackBar('Codigos LER actualizados correctamente', 'success');
        this.dialogRef.close({ saved: true });
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al actualizar los codigos LER', 'error');
      },
    });
  }

  hasMultiplePages(): boolean {
    const total = this.recordsTotal ?? 0;
    const size = this.pageSize ?? 0;
    return size > 0 && total > size;
  }

  private buildAvailableCodigos(allCodigos: any[], includedCodigos: any[]): any[] {
    const includedIds = new Set((includedCodigos ?? []).map((item: any) => item?.id));
    return this.sortByOrden((allCodigos ?? []).filter((item: any) => item?.id && !includedIds.has(item.id)));
  }
}
